import React, { useEffect, useState, useRef } from "react";
import { Loginwrapper } from "../style";
import Input from "../../ui/Input";
import Button from "../../ui/Button";
import OtpInput from "../../OtpInput/OtpInput";
import imgLogin from "../../../images/loginImg.png";
import imgLogin2 from "../../../images/loginBanner.jpg";
import { FaRupeeSign, FaCity } from "react-icons/fa";
import { FaMoneyBillWave, FaSmile } from "react-icons/fa";
import { motion } from "framer-motion";
// import rightImage from "../../../images/instant_loan.jpg";
import rightImage from "../../../images/loan_info_image.jpg"
import verificationIcon from "../../../images/banner.png";
import { Send } from "lucide-react";
import {
  FaRocket,
  FaUsers,
  FaLightbulb,
  FaCheckCircle,
  FaShieldAlt,
  FaMobileAlt,
  FaClock,
} from "react-icons/fa";
import { GiReceiveMoney, GiArchiveResearch } from "react-icons/gi";
import {
  getStorage,
  isEmpty,
  isNumber,
  setStorage,
  getStoredUTM,
} from "../../../Utils/common";
import { Link, useNavigate } from "react-router-dom";
import {
  sendotpForLogin,
  verifyotpForLogin,
  ckeckEligibility,
} from "../../../Utils/api";
import Alert from "../../ui/Alert";
import MobileInput from "../../OtpInput/MobileInput";

function Login() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [screen, setScreen] = useState("getOtp");
  const [seconds, setSeconds] = useState(0);
  const [mobile, setMobile] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [mobileError, setMobileError] = useState("");
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [acceptError, setAcceptError] = useState("");
  const [message, setMessage] = useState({});
  const [responce, setResponce] = useState({});
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);

  // Extract UTM parameters from the URL
  const getUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    const utm = getStoredUTM();
    return {
      utm_source: params.get("utm_source") || utm?.utm_source || utm?.referrer || "",
      utm_medium: params.get("utm_medium") || utm?.utm_medium || "",
      utm_campaign: params.get("utm_campaign") || utm?.utm_campaign || "",
      utm_term: params.get("utm_term") || utm?.utm_term || "",
      utm_content: params.get("utm_content") || utm?.utm_content || "",
    };
  };

  useEffect(() => {
    if (screen === "getOtp") return;
    const timer = setInterval(() => {
      if (seconds === 0) {
        clearInterval(timer);
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [seconds]);

  const onChanges = (e, type) => {
    const { name, value } = e.target;

    if (type === "sendOtp") {
      if (!isNumber(value) && !isEmpty(value)) return;
      setMobile(value);
      setMobileError("");
    }
  };

  const sendOtp = () => {
    let mobileNumber = mobile.join("");
    if (mobileNumber.length < 10) {
      setMobileError(
        "The Mobile field must be at least 10 characters in length."
      );
      return;
    }
    if (!accept) {
      setAcceptError(
        "Please check the checkbox to accept our terms and conditions"
      );
      return;
    } else {
      setAcceptError("");
    }

    // Get UTM parameters from the URL
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } =
      getUtmParams();

    const param = {
      mobile: mobileNumber,
      event_name: "login",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    };

    setLoading(true);
    sendotpForLogin(param).then((resp) => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setStorage("mobile", mobileNumber);
        setStorage("cust_profile_id", resp?.data?.Data?.cust_profile_id);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });
      } else {
        setMobile(["", "", "", "", "", "", "", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg =
          resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: "error", msg: msg });
      }
    });
  };

  const resendOtp = () => {
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } =
      getUtmParams();

    const param = {
      profile_id: getStorage("cust_profile_id"),
      event_name: "resend_otp",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    };

    setLoading(true);
    sendotpForLogin(param).then((resp) => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });
      } else {
        setMobile(["", "", "", "", "", "", "", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg =
          resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: "error", msg: msg });
      }
    });
  };

  const verifyOTP = async () => {
    let otpNumber = otp.join("");

    if (otpNumber.length !== 4) {
      setMessage({ type: "error", msg: "Please enter 4 digits OTP" });
      return;
    }

    const param = {
      event_name: "otp_verify",
      profile_id: getStorage("cust_profile_id"),
      otp: otpNumber,
    };

    setLoading(true);
    try {
      const resp = await verifyotpForLogin(param);

      setLoading(false);

      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setStorage("next_step", resp?.data?.Data?.next_step);
        setStorage("token", resp?.data?.Data?.app_login_token);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });

        if (resp?.data?.Data?.eligibility_status === 1) {
          setStorage("eligibility", 1); // Store eligibility as 1 if eligible
        } else {
          setStorage("eligibility", 0); // Store eligibility as 0 if not eligible
        }

        // Navigate based on eligibility
        if (getStorage("eligibility") === 1) {
          console.log("Navigating to /my-dashboard/eligibility");
          navigate("/my-dashboard/eligibility");
        } else {
          console.log("Navigating to /my-dashboard");
          navigate("/my-dashboard");
        }
      } else {
        setOtp(["", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg =
          resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: "error", msg: msg });
      }
    } catch (err) {
      setLoading(false);
      setMessage({ type: "error", msg: "Error verifying OTP" });
      console.error("OTP Verification Error:", err);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      verifyOTP();
    }
  };

  useEffect(() => {
    if (isEmpty(message)) return;
    const timer = setTimeout(() => {
      setMessage({});
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [message]);

  useEffect(() => {
    const counters = document.querySelectorAll(".counter");
    counters.forEach((counter) => {
      const updateCount = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText.replace(/,/g, "");
        const increment = target / 200;
        if (count < target) {
          counter.innerText = Math.ceil(count + increment).toLocaleString();
          setTimeout(updateCount, 20);
        } else {
          counter.innerText = target.toLocaleString();
        }
      };
      updateCount();
    });
  }, []); // empty dependency -> run once on mount
  const cardVariants = {
    hiddenLeft: { opacity: 0, x: -100 },
    hiddenRight: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
  };

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* <Loginwrapper className="flex"> */}
      {/* <div className="left">
          <img src={imgLogin2} alt="" />
          <div className="textBox">
            <h2>
              Need an <br /> instant loan
            </h2>
            <div>Up to ₹100,000</div>
          </div>
        </div> */}
      {/* <div
          className="bg-white right max-w-[413] min-h-[417] rounded-full"
        >
          <div className="form" style={{ maxWidth: "400px" }}>
            <Alert setMessage={setMessage} message={message} />
            <h2 style={{ fontSize: "26px" }}>Apply for a Personal Loan</h2>
            {screen === "getOtp" ? (
              <>
                <p className="text-black"
                >
                  Enter your 10 digit mobile number to get started
                </p>
                <div className="otpBox">
                  <MobileInput
                    name="mobile"
                    setOtp={setMobile}
                    otp={mobile}
                    isDisable={false}
                    error={mobileError}
                    onChange={(e) => onChanges(e, "sendOtp")}
                    placeholder="_"
                    onKeyDown={handleKeyDown}
                    inputRefs={inputRefs}
                  />
                </div>
                <div
                  className="flex confirm"
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    textAlign: "justify",
                  }}
                >
                  <input
                    style={{
                      height: "15px",
                      marginRight: "10px",
                    }}
                    name="radio"
                    type="checkbox"
                    checked={accept}
                    onChange={() => {
                      setAccept(!accept);
                      setAcceptError("");
                    }}
                  />
                  <p className="text-gray-500">
                    By selecting this checkbox, I authorize the receipt of
                    digital communications
                    {showMore ? (
                      <span>
                        , such as phone calls, SMS, emails, and WhatsApp
                        messages, at the phone number, email address, and app I
                        have provided from Speedoloan. Furthermore, I
                        acknowledge that I have reviewed and accept the ,{" "}
                        <Link to="/termsandconditions">
                          Terms and Conditions
                        </Link>{" "}
                        and <Link to="/privacypolicy"> Privacy Policy</Link>.
                      </span>
                    ) : (
                      <span>
                        <button
                          onClick={() => setShowMore(true)}
                          style={{
                            cursor: "pointer",
                            border: "none",
                            background: "none",
                            color: "#4FA0FF",
                            textDecoration: "none",
                          }}
                        >
                          read more
                        </button>
                      </span>
                    )}
                  </p>
                </div>
                {acceptError && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {acceptError}
                  </p>
                )}
                <div className="button">
                  <Button
                    title="Send OTP"
                    onClick={sendOtp}
                    loading={loading}
                  />
                </div>
              </>
            ) : (
              <>
                <p
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    marginBottom: "18px",
                  }}
                >
                  Mobile number : ******
                  {getStorage("mobile") && getStorage("mobile").length >= 10
                    ? getStorage("mobile").slice(-4)
                    : "N/A"}
                </p>
                <p>Please enter the OTP to unlock your next step.</p>
                <div className="otpBox">
                  <OtpInput
                    type="text"
                    setOtp={setOtp}
                    otp={otp}
                    isDisable={false}
                    placeholder="*"
                    onKeyDown={handleKeyDown}
                    inputRefs={inputRefs}
                  />
                </div>
                <div className="button">
                  <Button
                    title="Verify OTP"
                    onClick={verifyOTP}
                    loading={loading}
                  />
                </div>
                <div className="resend">
                  {seconds > 0 ? (
                    <p className="none">
                      Didn't receive the OTP?{" "}
                      <FontAwesomeIcon
                        icon={faClock}
                        style={{
                          marginRight: "5px",
                          marginLeft: "5px",
                          color: "red",
                        }}
                      />{" "}
                      <span style={{ color: "red", fontWeight: 600 }}>
                        00:{seconds}s
                      </span>
                    </p>
                  ) : (
                    <button
                      onClick={!loading ? resendOtp : () => { }}
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid #4FA0FF",
                        color: "#4FA0FF",
                        padding: "10px 9px",
                        borderRadius: "25px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontFamily: "Roboto, sans-serif",
                        transition: "background-color 0.3s, color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#4FA0FF";
                        e.target.style.color = "#fff";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#4FA0FF";
                      }}
                    >
                      Resend OTP
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </div> */}
      {/* </Loginwrapper> */}
      <Loginwrapper className="relative min-h-screen w-full flex items-center justify-center">
        {/* Background Video - SAME */}
        {/* <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          src="/videos/bg.mp4"
        /> */}

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>

        {/* MAIN JOINED CARD */}
        <div
          className="
      relative z-10 w-full max-w-5xl 
      grid grid-cols-1 md:grid-cols-2
      bg-white/10 backdrop-blur-2xl
      border border-white/20
      rounded-3xl shadow-2xl overflow-hidden
    "
        >
          {/* LEFT IMAGE SECTION */}
          <div className=" md:block relative">
            <img
              src={rightImage}
              alt="Loan Illustration"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
          </div>

          {/* RIGHT FORM SECTION – DARKER & ALIGNED */}
          <div
            className=" absolute h-full   bg-[#07152D]/95
    p-5 md:p-10 text-white 
    border border-white/10
    shadow-2xl
    relative overflow-hidden 
    flex flex-col items-center justify-start
  "
          >
            {/* Decorative Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-black/20 to-transparent pointer-events-none"></div>

            {/* TOP ICON */}
            <div
              className="
      w-20 h-20 rounded-full
      bg-blue-500/20 border border-blue-400/30
      flex items-center justify-center
      mb-6 backdrop-blur-xl shadow-lg
    "
            >
              <img
                src={verificationIcon}
                alt="verification"
                className="w-22 h-12 object-contain"
              />
            </div>

            {/* Heading */}
            <div className="text-3xl font-bold mb-2  tracking-wide text-center">
              <span className="text-white">Apply for</span>
              <span className="text-blue-500"> Personal Loan</span>
            </div>

            <p className="text-gray-300 text-sm text-center max-w-xs mb-6 leading-relaxed">
              Verify your mobile number to continue the quick loan process.
            </p>

            <Alert setMessage={setMessage} message={message} />

            {/* GET OTP */}
            {screen === "getOtp" ? (
              <>
                <label className="text-white text-sm mb-2 block w-full text-left">
                  Enter Mobile Number
                </label>

                <div
                  className="  
        rounded-2xl  mb-4 flex items-center text-[white] w-full shadow-inner [&_input]:text-white
    [&_input::placeholder]:text-white/50
      "
                >
                  <MobileInput className="otp-text"
                    name="mobile"
                    setOtp={setMobile}
                    otp={mobile}
                    error={mobileError}
                    isDisable={false}
                    onChange={(e) => onChanges(e, "sendOtp")}
                    placeholder="_"
                    onKeyDown={handleKeyDown}
                    inputRefs={inputRefs}
                  />
                </div>

                {/* Checkbox */}
                <label className="flex items-start gap-3 cursor-pointer w-full">
                  {/* CHECKBOX WRAPPER (prevents movement) */}
                  <span className="flex-shrink-0 mt-1">
                    <input
                      type="checkbox"
                      checked={accept}
                      onChange={() => {
                        setAccept(!accept);
                        setAcceptError("");
                      }}
                      className="
        h-5 w-5
        appearance-none
        rounded-md
        border-2 border-blue-400
        bg-transparent
        checked:bg-blue-500 checked:border-blue-500
        focus:outline-none
        transition-colors
      "
                    />
                  </span>

                  {/* TEXT CONTENT */}
                  <span className="text-gray-300 text-sm leading-relaxed">
                    I authorize communication for verification.
                    {showMore ? (
                      <>
                        <br />I accept the{" "}
                        <Link
                          to="/termsandconditions"
                          className="text-blue-400 underline"
                          onClick={(e) => e.stopPropagation()}
                        >
                          Terms
                        </Link>{" "}
                        &{" "}
                        <Link
                          to="/privacypolicy"
                          className="text-blue-400 underline"
                          onClick={(e) => e.stopPropagation()}
                        >
                          Privacy Policy
                        </Link>
                        .
                      </>
                    ) : (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowMore(true);
                        }}
                        className="text-blue-300 underline ml-1 bg-[transparent] border-none"
                      >
                        read more
                      </button>
                    )}
                  </span>
                </label>

                {acceptError && (
                  <p className="text-red-400 text-xs mt-2">{acceptError}</p>
                )}
                <div className="w-full ">


                  <Button

                    className="
          w-full py-3 mt-6 rounded-xl
          bg-gradient-to-r from-blue-500 to-blue-600
          text-white font-semibold
          shadow-xl shadow-blue-500/30
          hover:opacity-90 transition-all
        "

                    title=" Send OTP"
                    onClick={sendOtp}
                    loading={loading}

                  />
                </div>

              </>
            ) : (
              <>
                {/* OTP SCREEN */}
                <p className="text-gray-300 text-sm mb-1 text-center">
                  OTP sent to ******{getStorage("mobile")?.slice(-4)}
                </p>

                <p className="text-gray-300 mb-4 text-sm text-center">
                  Enter the 6-digit verification code.
                </p>

                <div
                  className="
        
        rounded-2xl px-4 py-5 mb-4
        shadow-inner w-full text-center
      "
                >
                  <OtpInput
                    type="text"
                    setOtp={setOtp}
                    otp={otp}
                    isDisable={false}
                    placeholder="*"
                    onKeyDown={handleKeyDown}
                    inputRefs={inputRefs}
                  />
                </div>

                <Button
                  className="
          w-full py-3 mt-2 rounded-xl
          bg-gradient-to-r from-blue-500 to-blue-600
          text-white font-semibold
          shadow-xl shadow-blue-500/30
          hover:opacity-90 transition-all
        "
                  title="Verify OTP"
                  onClick={verifyOTP}
                  loading={loading}
                />

                <div className="mt-4 text-gray-300 text-sm text-center">
                  {seconds > 0 ? (
                    <p>
                      Resend in{" "}
                      <span className="text-red-400 font-medium">
                        00:{seconds}s
                      </span>
                    </p>
                  ) : (
                    <button
                      className="text-blue-400 underline bg-[transparent]  border-none"
                      onClick={!loading ? resendOtp : () => { }}
                    >
                      Resend OTP
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </Loginwrapper>

      {/* <div className="services_page_section" data-aos="zoom-in">
        <div className="services_row">
          <Link to="/instant-loan">
            <div className="services_item">
              <div className="services_icon_container">
                <GiPayMoney className="services_icon" />
              </div>
              <div className="services_content">
                <div className="services_title">
                  <h4>Instant Loan</h4>
                </div>
                <p>
                  We offer instant loans to help you tackle unexpected financial
                  needs swiftly and efficiently.
                </p>
              </div>
            </div>
          </Link>
          <Link to="/short-term-loan">
            <div className="services_item">
              <div className="services_icon_container">
                <GiTakeMyMoney className="services_icon" />
              </div>
              <div className="services_content">
                <div className="services_title">
                  <h4>Short Loan</h4>
                </div>
                <p>
                  Discover the convenience of short loans at Speedoloan,
                  designed to meet your immediate financial needs with ease.
                </p>
              </div>
            </div>
          </Link>
          <Link to="/debt-consolidation-loan">
            <div className="services_item">
              <div className="services_icon_container">
                <VscCombine className="services_icon" />
              </div>
              <div className="services_content">
                <div className="services_title">
                  <h4>Debt Consolidation</h4>
                </div>
                <p>
                  Take control of your finances with our debt consolidation
                  services. Consolidate multiple debts into one manageable
                  payment
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div> */}

      {/* 2. Instant Loan Approval */}
      {/* <div className="max-w-7xl mx-auto px-4 py-8">
        {[
          {
            title: "Instant Loan Approval",
            description:
              "Apply and get approved for a loan within minutes. Our automated system ensures that you receive instant decisions based on your profile.",
            image: "/images/about/about-1.jpg",
            icon: <GiReceiveMoney className="text-[#4FA0FF] text-3xl" />,
            bgColor: "bg-blue-50",
            reverse: false,
            points: [
              {
                text: "Approval in as little as 5 minutes",
                icon: <FaClock className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "24/7 application processing",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Real-time status updates",
                icon: <FaMobileAlt className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
          {
            title: "100% Digital Process",
            description:
              "Experience a paperless journey from start to finish. Upload your documents, verify your details, and get disbursal—all online.",
            image: "/images/about/about-2.jpg",
            icon: <GiArchiveResearch className="text-[#4FA0FF] text-3xl" />,
            bgColor: "bg-indigo-50",
            reverse: true,
            points: [
              {
                text: "No physical paperwork required",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "eKYC and digital signatures",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Instant document verification",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
          {
            title: "Secure & Trusted",
            description:
              "Your data is safe with us. We use industry-grade encryption and privacy standards to keep your information secure at all times.",
            image: "/images/about/about-3.jpg",
            icon: <FaShieldAlt className="text-[#4FA0FF] text-3xl" />,
            bgColor: "bg-purple-50",
            reverse: false,
            points: [
              {
                text: "Bank-level security protocols",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Regular security audits",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "GDPR compliant data handling",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
        ].map((feature, index) => (
          <section
            key={index}
            className={`my-16 ${
              feature.bgColor
            } rounded-2xl overflow-hidden flex flex-col ${
              feature.reverse ? "md:flex-row-reverse" : "md:flex-row"
            } shadow-sm border border-gray-200 group`}
          >
            <div className="flex-1 min-w-[300px] p-8 md:p-12 flex flex-col justify-center">
              <div className="flex items-center mb-5">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-md mr-4">
                  {feature.icon}
                </div>
                <h2 className="text-2xl font-bold text-[#1D3557] m-0">
                  {feature.title}
                </h2>
              </div>
              <p className="text-gray-600 text-lg leading-relaxed mb-8">
                {feature.description}
              </p>
              <ul className="list-none p-0 m-0">
                {feature.points.map((point, i) => (
                  <li key={i} className="flex items-center mb-3 text-gray-600">
                    {point.icon}
                    {point.text}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-1 min-w-[300px] min-h-[400px] relative flex items-center justify-center p-0 overflow-hidden">
              <div
                className={`absolute inset-0 ${
                  feature.reverse ? "bg-gradient-to-r" : "bg-gradient-to-l"
                } from-[#4FA0FF]/5 to-transparent`}
              ></div>
              <img
                src={feature.image}
                alt={feature.title}
                className="relative z-10 w-full h-full max-h-[400px] object-cover shadow-lg transition-transform duration-300 group-hover:scale-105  "
              />
            </div>
          </section>
        ))}
      </div> */}

      <div className=" mx-auto px-4 py-12 bg-[#050A18]">
        {/* === Counter Section === */}
        <div className="max-w-7xl mx-auto px-4 py-12 bg-[#050A18] text-center">
          {/* Heading */}

          <div className="text-3xl md:text-4xl font-bold mb-3">
            <span className="text-white">Our Achievements</span>
            <span className="text-[#4FA0FF]"> at a Glance</span>
          </div>

          <p className="text-gray-400 mb-10 text-lg">
            Millions of families trust us. Here's a quick look at our impact.
          </p>

          {/* Counters Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
            {[
              {
                target: 15000,
                label: "Trusted Families",
                symbol: "+",
                icon: <FaUsers className="text-[white] text-3xl" />,
                points: [
                  "Over 10 years of experience",
                  "Millions of happy clients",
                ],
              },
              {
                target: 5000,
                label: "Loans Disbursed",
                symbol: "+",
                icon: <FaMoneyBillWave className="text-[white] text-3xl" />,
                points: [
                  "Fast approval within minutes",
                  "Flexible repayment options",
                ],
              },
              {
                target: 98,
                label: "Customer Satisfaction",
                symbol: "%",
                icon: <FaSmile className="text-[white] text-3xl" />,
                points: [
                  "24/7 customer support",
                  "Trusted by thousands nationwide",
                ],
              },
            ].map((counter, i) => (
              <div
                key={i}
                className="bg-[#111827] backdrop-blur-md rounded-2xl p-8 border border-white/20 shadow-lg hover:shadow-blue-300/30 transition flex flex-col items-center justify-center"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-[#1E293B] rounded-full flex items-center justify-center mb-4 shadow-md">
                  {counter.icon}
                </div>

                {/* Counter */}
                <h3 className="text-4xl font-bold text-[#4FA0FF] flex justify-center items-center gap-1">
                  <span className="counter" data-target={counter.target}>
                    0
                  </span>
                  <span className="text-[#4FA0FF]">{counter.symbol}</span>
                </h3>

                {/* Label */}
                <p className="mt-2 text-gray-300 text-lg">{counter.label}</p>

                {/* Small Points */}
                <ul className="mt-3 text-gray-400 text-sm list-disc list-inside space-y-1">
                  {counter.points.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* === Cards Section === */}
        {[
          {
            title: "Instant Loan Approval",
            description:
              "Apply and get approved for a loan within minutes. Our automated system ensures that you receive instant decisions based on your profile.",
            image: "/images/about/about-1.jpg",
            icon: <GiReceiveMoney className="text-[#4FA0FF] text-3xl" />,
            reverse: false,
            points: [
              {
                text: "Approval in as little as 5 minutes",
                icon: <FaClock className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "24/7 application processing",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Real-time status updates",
                icon: <FaMobileAlt className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
          {
            title: "100% Digital Process",
            description:
              "Experience a paperless journey from start to finish. Upload your documents, verify your details, and get disbursal—all online.",
            image: "/images/about/about-2.jpg",
            icon: <GiArchiveResearch className="text-[#4FA0FF] text-3xl" />,
            reverse: true,
            points: [
              {
                text: "No physical paperwork required",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "eKYC and digital signatures",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Instant document verification",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
          {
            title: "Secure & Trusted",
            description:
              "Your data is safe with us. We use industry-grade encryption and privacy standards to keep your information secure at all times.",
            image: "/images/about/about-3.jpg",
            icon: <FaShieldAlt className="text-[#4FA0FF] text-3xl" />,
            reverse: false,
            points: [
              {
                text: "Bank-level security protocols",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Regular security audits",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "GDPR compliant data handling",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
        ].map((feature, index) => (
          <motion.section
            key={index}
            initial={feature.reverse ? "hiddenRight" : "hiddenLeft"}
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={cardVariants}
            className={`my-16 rounded-2xl overflow-hidden flex flex-col md:flex-row ${feature.reverse ? "md:flex-row-reverse" : ""
              } shadow-sm border border-gray-700 bg-[#111827]/70 backdrop-blur-md`}
          >
            <div className="flex-1 min-w-[300px] p-8 md:p-12 flex flex-col justify-center">
              <div className="flex items-center mb-5">
                <div className="w-12 h-12 bg-[#1E293B] rounded-lg flex items-center justify-center shadow-md mr-4">
                  {feature.icon}
                </div>
                <h2 className="text-2xl font-bold text-white m-0">
                  {feature.title}
                </h2>
              </div>
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                {feature.description}
              </p>
              <ul className="list-none p-0 m-0">
                {feature.points.map((point, i) => (
                  <li key={i} className="flex items-center mb-3 text-gray-300">
                    {point.icon}
                    {point.text}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-1 min-w-[300px] min-h-[400px] relative flex items-center justify-center p-0 overflow-hidden">
              <div
                className={`absolute inset-0 ${feature.reverse ? "bg-gradient-to-r" : "bg-gradient-to-l"
                  } from-[#4FA0FF]/10 to-transparent`}
              ></div>
              <img
                src={feature.image}
                alt={feature.title}
                className="relative z-10 w-full h-full max-h-[400px] object-cover shadow-lg transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </motion.section>
        ))}

        {/* Scroll to Top Button */}
        {showScroll && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="
      fixed bottom-5 right-3 z-50
      w-12 h-12 flex items-center justify-center
      bg-[#4FA0FF] text-white text-2xl
      rounded-full shadow-lg
      transition-all duration-300
      border border-white/20
      backdrop-blur-md
      animate-fadeIn
      font-bold
    "
          >
            ↑
          </button>
        )}
      </div>
    </>
  );
}

export default Login;